import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GetOrdenTypes } from "../../../store/ordentype-store/ordentype-actions";
import ABADatatable from "../../../components/ABADatatable";
import { ordenTypeActions } from "../../../store/ordentype-store/ordentype-slice";
import { Button } from "primereact/button";

const OrdenTypeHomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ordenType = useSelector((state) => state.ordenType);
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    if (auth.roles !== undefined && auth.roles.includes("ordentype.showAll")) {
      dispatch(GetOrdenTypes(auth.UserInfo.email));
    }
  }, [dispatch, auth]);

  const viewDetailHanlder = (val) => {
    navigate(`/orden/type/detail/${val.id}`);
  };
  const editHanlder = (val) => {
    navigate(`/orden/type/edit/${val.id}`);
  };
  const createHanlder = () => {
    dispatch(
      ordenTypeActions.setOrdenType({
        ordenType: {
          Descripcion: "",
        },
      })
    );
    navigate(`/orden/type/create`);
  };
  const backHanlder = () => {
    navigate(`/`);
  };
  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonEdit = (
      <Button
        label="Editar"
        icon="pi pi-file-edit"
        className="p-button-rounded p-button-success p-button-text"
        onClick={() => {
          editHanlder(rowData);
        }}
      />
    );
    const buttonView = (
      <Button
        label="Ver"
        icon="pi pi-info-circle"
        className="p-button-rounded p-button-text"
        onClick={() => {
          viewDetailHanlder(rowData);
        }}
      />
    );
    if (auth.roles !== undefined && auth.roles.includes("ordentype.edit")) {
      buttons.push(buttonEdit);
    }
    if (auth.roles !== undefined && auth.roles.includes("ordentype.view")) {
      buttons.push(buttonView);
    }
    return buttons;
  };
  actions.push(buttons);

  const columns = [
    {
      field: "name",
      header: "Tipo de orden",
      filterMatchMode: "contains",
    },
    {
      field: "status",
      header: "Estado",
      filterMatchMode: "contains",
    },
  ];
  return (
    <>
      <ABADatatable
        title="Tipo de ordenes"
        values={ordenType.ordenTypes}
        rows={5}
        rowsPerPageOptions={[5, 10, 20]}
        Columns={columns}
        actions={actions}
        createButton={{
          label: "Crear Tipo de orden",
          onClick: createHanlder,
          permission: "ordentype.create",
        }}
        backButton={{
          label: "Regresar",
          onClick: backHanlder,
          permission: "goBack",
        }}
      />
    </>
  );
};
export default OrdenTypeHomePage;
